import { render, staticRenderFns } from "./branded-fare-upsell-swiper-item.vue?vue&type=template&id=14ac54d4&scoped=true"
import script from "./branded-fare-upsell-swiper-item.vue?vue&type=script&lang=js"
export * from "./branded-fare-upsell-swiper-item.vue?vue&type=script&lang=js"
import style0 from "./branded-fare-upsell-swiper-item.vue?vue&type=style&index=0&id=14ac54d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ac54d4",
  null
  
)

export default component.exports